module.exports = __webpack_public_path__ + "media/sword2.8ea178fa.wav";